export function removeMask(value: string) {
  if (value) return value.replace(/[^\d]+/g, "");
  return "";
}
